
import { defuFn } from 'defu'

const inlineConfig = {
  "cookieFirst": {
    "key": "36457fbc-dedb-4ca8-83be-e6b461e12c80"
  },
  "locations": [
    {
      "slug": "fra01",
      "endpoint": "https://fra01.latency.g-portal.com/ping"
    },
    {
      "slug": "pme01",
      "endpoint": "https://pme01.latency.g-portal.com/ping"
    },
    {
      "slug": "iad01",
      "endpoint": "https://iad01.latency.g-portal.com/ping"
    },
    {
      "slug": "lax01",
      "endpoint": "https://lax01.latency.g-portal.com/ping"
    },
    {
      "slug": "dfw02",
      "endpoint": "https://dfw02.latency.g-portal.com/ping"
    },
    {
      "slug": "crl01",
      "endpoint": "https://crl01.latency.g-portal.com/ping"
    },
    {
      "slug": "syd01",
      "endpoint": "https://syd01.latency.g-portal.com/ping"
    },
    {
      "slug": "sin02",
      "endpoint": "https://sin02.latency.g-portal.com/ping"
    },
    {
      "slug": "cgh01",
      "endpoint": "https://cgh01.latency.g-portal.com/ping"
    },
    {
      "slug": "hnd01",
      "endpoint": "https://hnd01.latency.g-portal.com/ping"
    },
    {
      "slug": "tpe01",
      "endpoint": "https://tpe01.latency.g-portal.com/ping"
    },
    {
      "slug": "bom01",
      "endpoint": "https://bom01.latency.g-portal.com/ping"
    },
    {
      "slug": "hkg01",
      "endpoint": "https://hkg01.latency.g-portal.com/ping"
    }
  ],
  "supportedCurrencies": [
    "EUR",
    "USD",
    "JPY",
    "GBP",
    "AUD"
  ],
  "nuxt": {}
}

/** client **/
import { _replaceAppConfig } from '#app/config'

// Vite - webpack is handled directly in #app/config
if (import.meta.dev && !import.meta.nitro && import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    _replaceAppConfig(newModule.default)
  })
}
/** client-end **/



export default /*@__PURE__*/ defuFn(inlineConfig)
